import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '小乐智行 - 自动驾驶教育与车路协同解决方案',
            description: '小乐智行专注自动驾驶教育、车路协同（V2X）、SLAM建图、计算机视觉与数字孪生仿真技术，提供DeepCar自动驾驶小车、智慧交通数字孪生沙盘、AutoSim仿真系统等产品，面向高校、职业教育与科研机构提供端到端教学实训方案。'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/znwl'
            },
            {
              path: '/software/znwl',
              name: 'software',
              component: resolve => require(['@/view/Software_znwl'], resolve),
              meta: {
                title: '智能网联汽车软件产品 - 小乐智行',
                description: '智能网联汽车教学软件平台，支持车路协同协议栈开发、V2X通信实验与自动驾驶算法验证，面向高校与职业教育提供完整的软件教学实训环境。'
              }
            },
            /* AI体育和数字人员工已移除 */
          ]
        }, {
          path: '/solutions',
          name: 'solutions',
          component: resolve => require(['@/view/Solutions'], resolve),
          meta: {
            title: '解决方案'
          },
          children: [
            {
              path: '/solutions',
              redirect: '/solutions/znwl'
            },
            {
              path: '/solutions/znwl',
              name: 'solutions',
              component: resolve => require(['@/view/Solution_znwl'], resolve),
              meta: {
                title: '智能网联汽车教学解决方案 - 小乐智行',
                description: '面向高校与职业院校的智能网联汽车教学解决方案，涵盖课程体系、实验平台、实训沙盘与项目案例，构建从理论到实践的完整教学闭环。'
              }
            },
            /* 数字员工和AI体育解决方案已移除 */
          ]
        }, { /* 新闻动态已移除 */
          path: '/cases',
          name: 'cases',
          component: resolve => require(['@/view/Cases'], resolve),
          meta: {
            title: '客户案例 - 小乐智行',
            description: '小乐智行服务的高校与科研机构客户案例，涵盖自动驾驶教学实训、智慧交通沙盘演示、车路协同实验平台等落地场景。'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍 - 小乐智行',
            description: '北京小乐智行科技有限公司，专注自动驾驶教育与车路协同技术，全栈自研ROS/ROS2算法、SLAM建图、计算机视觉与数字孪生仿真，为高校与科研机构提供端到端解决方案。'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会 - 小乐智行',
            description: '小乐智行诚邀自动驾驶、车路协同、计算机视觉领域的人才加入，提供有竞争力的薪资与成长空间。'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们 - 小乐智行',
            description: '联系小乐智行，获取产品咨询、方案定制与技术支持，工作日24小时内快速响应。'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务 - 小乐智行',
            description: '小乐智行提供产品交付、技术培训、课程共建与售后支持等全方位服务。'
          }
        },
        {
          path: '/product/sandbox',
          name: 'product-sandbox',
          component: resolve => require(['@/view/ProductDetail_sandbox'], resolve),
          meta: {
            title: '车路协同数字孪生沙盘系统 - 小乐智行',
            description: '智慧交通数字孪生沙盘系统，支持3D布局还原、车辆位置监控、V2X协同控制、设备控制与消息日志，全面覆盖车路协同教学演示场景。'
          }
        },
        {
          path: '/product/deepcar',
          name: 'product-deepcar',
          component: resolve => require(['@/view/ProductDetail_deepcar'], resolve),
          meta: {
            title: 'DeepCar 自动驾驶机器人小车 - 小乐智行',
            description: 'DeepCar自动驾驶机器人小车，面向Maker、职业教育与实验室研究，支持SLAM建图、图像识别与自主导航，快速上手无人驾驶技术学习。'
          }
        },
        {
          path: '/product/deepcar-pro',
          name: 'product-deepcar-pro',
          component: resolve => require(['@/view/ProductDetail_deepcar_pro'], resolve),
          meta: {
            title: 'DeepCar Pro 室外无人驾驶机器人 - 小乐智行',
            description: 'DeepCar Pro室外无人驾驶机器人，支持室外场景下的SLAM建图、路径规划与自主导航，适合高校科研与室外自动驾驶实验。'
          }
        },
        {
          path: '/product/v2x',
          name: 'product-v2x',
          component: resolve => require(['@/view/ProductDetail_v2x'], resolve),
          meta: {
            title: '路侧感知与V2X中控平台 - 小乐智行',
            description: '路侧感知与V2X中控平台，支持车路协同通信、路侧感知数据处理与交通信号控制，构建完整的车路协同教学实验环境。'
          }
        },
        {
          path: '/product/education',
          name: 'product-education',
          component: resolve => require(['@/view/ProductDetail_education'], resolve),
          meta: {
            title: '智慧交通教学实训方案 - 小乐智行',
            description: '面向高校与职业院校的智慧交通教学实训方案，包含模块化课程体系、项目案例与实验手册，构建从理论到实践的完整教学闭环。'
          }
        }, {
          path: '/product/autosim',
          name: 'product-autosim',
          component: resolve => require(['@/view/ProductDetail_autosim'], resolve),
          meta: {
            title: 'AutoSim 智能车仿真系统 - 小乐智行',
            description: 'AutoSim智能车仿真系统，支持自动驾驶算法仿真测试、虚拟场景构建与虚实融合仿真，为教学与科研提供安全的仿真实验环境。'
          }
        }, {
          path: '/product/ai-platform',
          name: 'product-ai-platform',
          component: resolve => require(['@/view/ProductDetail_ai_platform'], resolve),
          meta: {
            title: '一站式人工智能教学平台 - 小乐智行',
            description: '一站式人工智能教学平台，集成在线IDE（JupyterLab）、教学管理、课程资源与AI实验环境，面向高校提供一体化AI教学解决方案。'
          }
        }, {
          path: '/downloads',
          name: 'downloads',
          component: resolve => require(['@/view/Downloads'], resolve),
          meta: {
            title: '产品资料下载 - 小乐智行',
            description: '下载小乐智行产品手册、技术白皮书与实验指导资料，获取自动驾驶教学与车路协同方案的详细文档。'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js